module.exports = __webpack_public_path__ + "img/0Q3A6289_L_Foamcore_MockedUp.3ba57fc1.jpg";